import React from "react";
// import $ from "jquery"
import "./homeSection.css";
import { Parallax } from "react-parallax";
import Link from "gatsby-link";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";
// const image1 =
// "https://winpeforum.com/assets/elements/alicorn_hero_banner2.jpg";
const image1 = "https://winpeforum.com/assets/elements/HeroImg.jpg";

export class HomeSection extends React.Component {
  constructor(args) {
    super(args);
    this.state = {};
  }
  componentDidMount() {
    // $(document).ready(function(){
    // 	$('.parallax').parallax();
    // });
  }
  render() {
    const insideStyles = {
      background: "white",
      padding: 20,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
    };
    return (
      <div className="section__content">
        <div className="homeSection__wrapper">
          <Parallax bgImage={image1} strength={450}>
            <div style={{ height: "100%" }} className="homeSection__section">
              <div className="homeSection_content">
                <div className="text_section">
                  <div className="homeSection_text">
                    <ScrollAnimation
                      delay={0}
                      duration={2}
                      animateIn="slideInRight"
                      offset={600}
                    >
                      DIVERSITY IS NOW
                    </ScrollAnimation>
                  </div>
                  <div className="down_border"></div>
                  <div className="homeSection_text1">
                    <ScrollAnimation
                      delay={0}
                      duration={2}
                      animateIn="slideInLeft"
                      offset={600}
                    >
                      Women in Private Equity
                    </ScrollAnimation>
                  </div>
                  <div className="home_btn_section">
                    <div className="hone_btn">
                      <Link to="/events/">
                        <ScrollAnimation
                          delay={0}
                          duration={1}
                          animateIn="zoomIn"
                          offset={100}
                        >
                          <button>Upcoming Events</button>
                        </ScrollAnimation>
                      </Link>
                    </div>
                    <div className="hone_btn">
                      <Link to="/connect/">
                        <ScrollAnimation
                          delay={0}
                          duration={1}
                          animateIn="zoomIn"
                          offset={100}
                        >
                          <button>Connect</button>
                        </ScrollAnimation>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div style={{ height: "100%" }} className="homeSection__section">
              <div className="homeSection_content">
                <div className="text_section">
                  <div className="homeSection_text">
                    <ScrollAnimation
                      delay={0}
                      duration={2}
                      animateIn="slideInRight"
                      offset={600}
                    >
                      <span style={{ fontWeight: "400" }}>THE</span> ALICORN{" "}
                      <span style={{ fontWeight: "400" }}>LEADERSHIP</span>{" "}
                      <span style={{ color: "#DB3731" }}>SUMMIT</span>
                      <div
                        className="down_border"
                        style={{ margin: "40px auto" }}
                      ></div>
                      <span
                        style={{
                          marginBottom: "20px",
                          display: "inline-block",
                          fontSize: "30px",
                          //   fontWeight: "bold",
                          letterSpacing: "5px",
                        }}
                      >
                        Celebrating one year of Winpe
                      </span>
                    </ScrollAnimation>
                  </div> */}
            {/* <div className="homeSection_text1">
                    <ScrollAnimation
                      delay={0}
                      duration={2}
                      animateIn="slideInLeft"
                      offset={600}
                    >
                      December 2020- February 2021
                    </ScrollAnimation>
                  </div> */}
            {/* <div className="home_btn_section">
                    <div className="hone_btn">
                      <Link
                        to="/events"
                        onClick={() => history.push("/events")}
                      >
                        <ScrollAnimation
                          delay={0}
                          duration={1}
                          animateIn="zoomIn"
                          offset={100}
                        >
                          <button>Upcoming Events</button>
                        </ScrollAnimation>
                      </Link>
                    </div>
                    <div className="hone_btn">
                      <Link
                        to="/connect"
                        onClick={() => history.push("/connect")}
                      >
                        <ScrollAnimation
                          delay={0}
                          duration={1}
                          animateIn="zoomIn"
                          offset={100}
                        >
                          <button>Connect</button>
                        </ScrollAnimation>
                      </Link>
                    </div>
                  </div> 
                </div>
              </div>
            </div>*/}
          </Parallax>
        </div>
      </div>
    );
  }
}

export default HomeSection;



// WEBPACK FOOTER //
// ./src/components/homeSection/index.js